function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import noop from "lodash/noop";
import React from "react";
import ResizeObserver from "resize-observer-polyfill";
import getNewWidths from "../getNewWidths/index.js";
var useResizeObserver = function useResizeObserver(_ref, _ref2) {
  var minSlideWidth = _ref.minSlideWidth,
    maxSlideWidth = _ref.maxSlideWidth,
    gutter = _ref.gutter,
    responsive = _ref.responsive;
  var containerRef = _ref2.containerRef,
    totalSlidesCount = _ref2.totalSlidesCount;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    slideWidth = _React$useState2[0],
    setSlideWidth = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    maskWidth = _React$useState4[0],
    setMaskWidth = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    containerWidth = _React$useState6[0],
    setContainerWidth = _React$useState6[1];
  var resizeObserver = React.useRef();
  var animationFrameID = React.useRef();
  React.useEffect(function () {
    var container = containerRef.current;
    if (!container) {
      return noop;
    }
    var updateWidthData = function updateWidthData() {
      var newWidths = getNewWidths({
        minSlideWidth: minSlideWidth,
        maxSlideWidth: maxSlideWidth,
        gutter: gutter,
        responsive: responsive
      }, containerRef);
      setSlideWidth(newWidths.slideWidth);
      setMaskWidth(newWidths.maskWidth);
      setContainerWidth(newWidths.containerWidth);
    };
    resizeObserver.current = new ResizeObserver(function () {
      _globalThis.cancelAnimationFrame(animationFrameID.current);
      animationFrameID.current = _globalThis.requestAnimationFrame(function () {
        updateWidthData();
      });
    });
    resizeObserver.current.observe(container);
    updateWidthData();
    return function () {
      resizeObserver.current.unobserve(container);
      _globalThis.cancelAnimationFrame(animationFrameID.current);
    };
  }, [containerRef, minSlideWidth, maxSlideWidth, gutter, responsive]);
  return React.useMemo(function () {
    var visibleSlideSlots = slideWidth && maskWidth && Math.floor(maskWidth / slideWidth) || 0;
    var visibleSlidesCount = Math.min(visibleSlideSlots, totalSlidesCount);
    var takenSlideSpace = visibleSlidesCount * slideWidth;
    var extraPixels = containerWidth - takenSlideSpace;
    return {
      slideWidth: slideWidth,
      containerWidth: containerWidth,
      maskWidth: maskWidth,
      visibleSlideSlots: visibleSlideSlots,
      visibleSlidesCount: visibleSlidesCount,
      extraPixels: extraPixels
    };
  }, [slideWidth, containerWidth, maskWidth, totalSlidesCount]);
};
export default useResizeObserver;